import { CourseDTO } from "../domain/models/dto/CourseDTO";
import { ICourse } from "../domain/models/Course";
import { CourseModel } from "../models/Course";
import { FileMapper } from "./FileMapper";
import { CourseTranslationMapper } from "./CourseTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class CourseMapper extends SimpleMapper<ICourse, CourseDTO> {
    protected toDTOFields: string[] = ["id", "files", "translations"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = CourseModel;
    private fileMapper = new FileMapper();
    private courseTranslationMapper = new CourseTranslationMapper();

    toDTO(model: ICourse): CourseDTO {
        if (!model) {
            return null;
        }
        const baseDto = super.toDTO(model);
        baseDto.translations =
            model.translations?.map((t) =>
                this.courseTranslationMapper.toDTO(t),
            ) ?? [];
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];
        return baseDto;
    }

    fromDTO(dto: CourseDTO): ICourse {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);
        baseModel.translations =
            dto.translations?.map((t) =>
                this.courseTranslationMapper.fromDTO(t),
            ) ?? [];
        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
